import React, { useMemo } from 'react';
import './DraftItemRow.css';

export default function DraftItemRow({ type, item, onEdit, onDelete, onOpen, isCompact, isSelected, onToggleSelect, hideDate, hideIcon }) {
  const id = item?.id || item?.assignmentId || item?.eventId;
  const title = item?.title || item?.name || (type === 'event' ? 'Event' : 'Assignment');
  const location = item?.location || '';

  const parseLocal = (raw) => {
    if (!raw) return null;
    if (raw instanceof Date) return isNaN(raw.getTime()) ? null : raw;
    const s = String(raw).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, d] = s.split('-').map(Number);
      return new Date(y, m - 1, d);
    }
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  };

  const formatDate = (raw) => {
    const d = parseLocal(raw);
    if (!d) return '';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  };
  const formatTime = (raw) => {
    const d = parseLocal(raw);
    if (!d) return '';
    return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  };

  // dateLabel unused - computed inline in metaLine
  // const dateLabel = type === 'assignment'
  //   ? (item?.dueDate || (item?.dueDatetime ? String(item?.dueDatetime).split('T')[0] : ''))
  //   : (item?.start || item?.startDatetime || item?.date || '');

  const metaLine = useMemo(() => {
    if (type === 'event') {
      const dateStr = hideDate ? '' : formatDate(item?.start || item?.startDatetime || item?.date);
      const timeStr = formatTime(item?.start || item?.startTime || item?.startDatetime);
      const loc = (location || '').split(';')[0].split(',')[0].trim();
      const locShort = loc ? (loc.length > 40 ? loc.slice(0, 40) + '…' : loc) : '';
      return [dateStr, timeStr, locShort].filter(Boolean).join(' • ');
    }
    // assignment meta: date • optional time
    const dateStr = hideDate ? '' : (item?.dueDate || (item?.dueDatetime ? formatDate(item.dueDatetime) : ''));
    const timeStr = item?.dueTime || (item?.dueDatetime ? formatTime(item.dueDatetime) : '');
    return [dateStr, timeStr].filter(Boolean).join(' • ');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, item, location, hideDate]);

  const handleRowClick = (e) => {
    onOpen && onOpen(type, id);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit && onEdit(type, id);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete && onDelete(type, id);
  };

  return (
    <div className={`dir-row ${isCompact ? 'compact' : ''} ${isSelected ? 'isSelected' : ''} dir-type-${type}`} onClick={handleRowClick} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter') handleRowClick(); }}>
      <div className="dir-left">
        {onToggleSelect && (
          <span
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={0}
            className={`selectDot ${isSelected ? 'on' : ''}`}
            onClick={onToggleSelect}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggleSelect(e); } }}
          >
            <svg className="selectCheck" viewBox="0 0 12 12" fill="none">
              <path d="M2.5 6l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        )}
        {!hideIcon && (
          <div className="dir-icon" aria-hidden>
            {type === 'event' ? '📅' : '📝'}
          </div>
        )}
        <div className="dir-content">
          <div className={`dir-title ${type === 'assignment' ? 'assignment-title' : ''}`} title={title}>{title}</div>
          {metaLine && <div className="dir-meta" title={metaLine}>{metaLine}</div>}
        </div>
      </div>
      <div className="dir-right">
        <div className="dir-actions" onClick={(e)=>e.stopPropagation()}>
          <button className="dir-action-btn" title="Edit" onClick={handleEdit} aria-label="Edit">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/><path d="m15 5 4 4"/></svg>
          </button>
          <button className="dir-action-btn danger" title="Delete" onClick={handleDelete} aria-label="Delete">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>
          </button>
        </div>
      </div>
    </div>
  );
}
